import React from "react"

import { LoginOverlay } from "./LoginOverlay"
import { useLoginOverlayModel } from "./hooks/useLoginOverlayModel"

export const LoginOverlayConnector = React.memo(() => {
  return <LoginOverlay {...useLoginOverlayModel()} />
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    LOGIN_OVERLAY: null
  }
}
